/**
 * Service for handling Mailchimp-related operations
 */
export async function subscribeToNewsletter(formData) {
  try {
    const { firstName, lastName, email, daily, monthly } = formData;

    const response = await fetch('/api/newsletter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        daily,
        monthly
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.statusMessage || 'Failed to subscribe to newsletter');
    }

    return data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
}
